<template>
  <div>
    <ca-row>
      <ca-col size="2">
        <ca-button full-width @click="onEdit">Editar</ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-page>
          <ca-loader v-if="showLoading"></ca-loader>

          <template v-else>
            <ca-row>
              <ca-col>
                <ca-heading :text="company.name"></ca-heading>
                <ca-field label="CNPJ">
                  {{ company.registration }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col size="4">
                <ca-field label="Email Contato">
                  {{ company.contactEmail }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field :label="isLegalInscription ? 'Razão Social' : 'Nome'">
                  {{ company.name }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Classificação Tributária">
                  {{ company.taxationClass.description }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row v-if="isLegalInscription">
              <ca-col size="4">
                <ca-field label="Natureza Jurídica">
                  {{ company.legalNature.description }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Porte da empresa">
                  {{ company.companySize.description }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Cooperativa">
                  {{ company.cooperativeType.description }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col size="4">
                <ca-field label="Construtora">
                  {{ company.indConstru ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Desoneração da Folha">
                  {{ company.indExemptionPayroll ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Regime de Caixa">
                  {{ company.indCashRegime ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col size="4">
                <ca-field label="Registro Eletrônico de Empregados">
                  {{ company.indElectEmployeeRegistry ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>

              <ca-col size="4">
                <ca-field label="Participação no PAT">
                  {{ company.indPatParticipation ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>

              <ca-col v-if="isLegalInscription" size="4">
                <ca-field label="Número SIAFI">
                  {{ company.nrSiafi }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col v-if="isLegalInscription" size="4">
                <ca-field label="Fator Acidentário de Prevenção(FAP)">
                  {{ company.fap }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col size="4">
                <ca-field label="Data de Fundação">
                  {{ company.registrationDate | caDate }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Nome Contato">
                  {{ company.contactName }}
                </ca-field>
              </ca-col>

              <ca-col size="4">
                <ca-field label="CPF Contato">
                  {{ company.contactDocument | caCpf }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col size="4">
                <ca-field label="Telefone Contato">
                  {{ company.contactPhone }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Celular Contato">
                  {{ company.contactCellphone }}
                </ca-field>
              </ca-col>

              <ca-col v-if="isLegalInscription" size="4">
                <ca-field label="Situação Pessoa Jurídica">
                  {{ company.legalEntitySituation.description }}
                </ca-field>
              </ca-col>
              <ca-col v-else size="4">
                <ca-field label="Situação Pessoa Física">
                  {{ company.naturalPersonSituation.description }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col size="4">
                <ca-field label="Contagem de dias para Mensalistas">
                  {{ company.dayCountType.description }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Contagem de horas para Horistas">
                  {{ company.hourlyCountType.description }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row v-if="company.bankCode != null">
              <ca-col size="4">
                <ca-field label="Banco">
                  {{ company.bankCode.description }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Agência">
                  {{ company.bankAgency }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Conta Corrente">
                  {{ company.bankAccount }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col v-if="company.bankCode" size="4">
                <ca-field label="Convênio">
                  {{ company.bankAgreement }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Imprimir contas no holerite">
                  {{ company.indBankReceipt ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Mensagem no recibo">
                  {{ company.receiptMessage }}
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row vertical-offset="2">
              <ca-col v-if="company.bankCode != null" size="4">
                <ca-field label="Email aos trabalhadores">
                  {{ company.indEmailWorkers ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Arredondamento de Centavos em Líquidos">
                  {{ company.indRounding ? 'Sim' : 'Não' }}
                </ca-field>
              </ca-col>
              <ca-col size="4">
                <ca-field label="Situação no eSocial">
                  {{ company.statusEsocial.description }}
                </ca-field>
              </ca-col>
            </ca-row>
          </template>
        </ca-page>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
export default {
  name: 'EmployerViewPage',
  computed: {
    isLegalInscription() {
      return this.company.registrationType && this.company.registrationType.name === 'J';
    },
    company() {
      return this.$store.state.employer.company;
    },
    showLoading() {
      return !this.company;
    },
  },
  created() {
    this.$store.dispatch('employer/getEmployer');
  },
  methods: {
    onEdit() {
      this.$router.push({ name: 'EditEmployer' });
    },
  },
};
</script>
